module.exports = __webpack_public_path__ + "30704cdc1ded83e1e10dcc9f9ca51a61.png";